module.exports = __webpack_public_path__ + "assets/img/139.1a9c2dff.png";